import { Link } from 'react-router-dom';
import { allComics } from '@/mocks/comics';

export default function HotRanking() {
  const hotComics = [...allComics]
    .sort((a, b) => b.views - a.views)
    .slice(0, 8);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
              热门排行
            </h2>
            <p className="text-foreground-500 text-sm">根据阅读量排序，发现最受欢迎的漫画</p>
          </div>
          <Link
            to="/category"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {hotComics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group cursor-pointer animate-fade-in-up"
                style={{ animationDelay: `${index * 80}ms` }}
            >
              <div className="relative overflow-hidden rounded-xl bg-background-50 mb-3 aspect-[3/4]">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 香香漫画免费阅读`}
                  title={`${comic.title} - 韩漫日漫国漫免费在线阅读`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2 w-7 h-7 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-sm font-bold">
                  {index + 1}
                </div>
                {comic.status === '已完结' && (
                  <div className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-background-950/70 text-background-50 text-xs font-medium">
                    完结
                  </div>
                )}
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1 mb-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-400 line-clamp-1">{comic.author}</p>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}